var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"row start-lg start-md start-sm input-text"},[_c('div',{staticClass:"col-lg-12 col-md-12 col-sm-12"},[_c('app-form-input',{attrs:{"secondary":"","border-solid":"","placeholder":_vm.question.placeholder},model:{value:(_vm.value),callback:function ($$v) {_vm.value=$$v},expression:"value"}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }